import { render } from "./ListeBoitePostalePage.vue?vue&type=template&id=c33e36fc&ts=true"
import script from "./ListeBoitePostalePage.vue?vue&type=script&lang=ts"
export * from "./ListeBoitePostalePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__